import { SET_BLOG } from "../actions";
const blog = (state = [], action) => {
  switch (action.type) {
    case SET_BLOG:
      return [...action.value];
    default:
      return state;
  }
};
export default blog;
